import { useEffect, useState } from 'react'
import { FunnelIcon as OutlineFunnelIcon } from '@heroicons/react/24/outline'
import { FunnelIcon as SolidFunnelIcon } from '@heroicons/react/24/solid'

const FilterButton = ({
  filters, 
  onChange = () => {},
  defaultCheckedFilter = null
}) => {
  const defaultFilter = defaultCheckedFilter ? { [defaultCheckedFilter]: true } : {}

  const [selectedFilters, setSelectedFilters] = useState(defaultFilter) 
  const [solidIconStyle, setSolidIconStyle] = useState(false)

  useEffect(() => {
    setSelectedFilters(filters.reduce(
      (acc, f) => {
        return ({...acc, [f.value]: f.checked})
      },
      defaultFilter
    ))
  },[filters]) 

  useEffect(() => {
    // Vérifie si au moins un filtre est coché
    setSolidIconStyle(Object.values(selectedFilters).some(
      (checked) => checked
    ))
  }, [selectedFilters])

  // défini les filtres sélectionnés
  // ceux qui ont une clé (key) identique à celui modifié (checked ou unchecked)
  // seront unchecked
  // Permet de garder une cohérence dans les filtres sélectionnés :
  // par exemple : on ne peut pas sélectionner les personnes physiques et les personnes morales.
  // il faut tout désélectionner pour obtenir les deux.
  const handleCheckFilter = (f, value) => {
    const sameKeyFilters = filters.filter( (item) => 
      item.value !== f.value && item.key === f.key
    ).reduce( (acc, item) => ({...acc, [item.value]: false}), {} ) 
    setSelectedFilters({
      ...selectedFilters,
      [f.value]: value,
      ...sameKeyFilters
    })
  }

  const handleSelectedFilters = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const result = Object.keys(selectedFilters).reduce( (acc, value) => {
      if(selectedFilters[value]) {
        const filter = filters.find( (item) => item.value === value)
        if(filter) {
          acc[filter.key] = filter.value
        }
      }
      return acc
    }, {})
    onChange(result)
  }

  return (
    <div className="dropdown dropdown-end">
      <label tabIndex={0} className="btn btn-square btn-ghost p-2 m-1">
        { solidIconStyle ? <SolidFunnelIcon /> : <OutlineFunnelIcon />}
      </label>
      <div tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-100">
        <ul>
          {
            filters.map( (f, index) => (
              <li key={index}>
                <label className="label">
                  <input 
                    type="checkbox"
                    checked={selectedFilters[f.value] || false }
                    className='checkbox'
                    onChange={(e) => {
                      handleCheckFilter(f, e.target.checked)
                    }}
                  />
                  {f.label}
                </label>
              </li>
            ))
          }
        </ul>
        <div className='flex justify-between mt-2'>
          <button className="btn btn-sm"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setSelectedFilters(defaultFilter)
            }}
          >
            Reset
          </button>

          <button className="btn btn-sm"
            onClick={handleSelectedFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  )
}

export default FilterButton